import { atom } from 'recoil';

export const navbarToggleState = atom({
	key: 'navbarToggleState',
	default: '',
});
